import PropTypes from 'prop-types';
import React from 'react';
import { DIVIDER_APPEARANCES, DIVIDER_LENGTHS, ORIENTATIONS } from '../../constants';
import CustomPropTypes from '../../util/custom-prop-types';
import { StyledDivider } from './Divider.styles';

/**
 * @since 8.38.0
 */

export var Divider = function Divider(props) {
  return /*#__PURE__*/React.createElement(StyledDivider, props);
};
Divider.displayName = 'Divider';
Divider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The appearance of a divider.
   */
  appearance: PropTypes.oneOf(Object.values(DIVIDER_APPEARANCES)),
  /**
   * The length of a divider.
   *
   * Supports inline media query objects.
   */
  length: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(Object.values(DIVIDER_LENGTHS))),
  /**
   * The orientation of a divider.
   *
   * Supports inline media query objects.
   */
  orientation: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(Object.values(ORIENTATIONS))),
  /**
   * A [role](https://www.w3.org/TR/wai-aria-1.2/#roles) is required for assistive
   * technologies to announce the divider properly. Divider uses the
   * [separator](https://www.w3.org/TR/wai-aria-1.2/#separator) role.
   */
  role: PropTypes.string
} : {};
Divider.defaultProps = {
  appearance: DIVIDER_APPEARANCES.regular,
  length: DIVIDER_LENGTHS.auto,
  orientation: ORIENTATIONS.horizontal,
  role: 'separator'
};